import styled from 'styled-components'
import ErrorIllustration from '../../../assets/icons/error-illustration.svg'

import type { StyledSvgComponent } from '../../../types/svg'

export const ErrorIllustrationIcon = styled(ErrorIllustration as StyledSvgComponent)`
    width: 9.3125rem;
    height: 4.3125rem;
`
